import { GtmWindow } from '~sf/env';

type GtmPushProps = {
  event: string;
  eventProps: Record<string, unknown>;
};

export const gtmDataLayerPush = ({ event, eventProps }: GtmPushProps) => {
  if (!(window as unknown as GtmWindow).dataLayer) {
    return;
  }

  // eslint-disable-next-line functional/immutable-data
  (window as unknown as GtmWindow).dataLayer.push({
    event,
    eventProps,
  });
};
